
import React from 'react';
import { Card, CardHeader, CardContent, CardFooter, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Tag, Calendar, Clock } from 'lucide-react';
import { RentalInfo } from '@/hooks/types/rentalTypes';
import { formatDate } from '@/utils/dateUtils';

interface ActiveRentalTariffCardProps {
  rental: RentalInfo;
  currentTariff: string | null;
  onSelectOtherTariffs: () => void;
  onExtendTariff: () => void;
}

export const ActiveRentalTariffCard = ({ 
  rental, 
  currentTariff, 
  onSelectOtherTariffs,
  onExtendTariff
}: ActiveRentalTariffCardProps) => {
  const getTariffName = (amount: number): string => {
    if (amount >= 14000) return 'Аренда Месяц';
    if (amount >= 8000) return 'Аренда 2 Недели';
    if (amount >= 4500) return 'Аренда Неделя';
    return 'Стандартный тариф';
  };

  return (
    <Card className="w-full bg-card/80 shadow-md">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Tag className="h-5 w-5" /> 
          Тариф
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="p-3 bg-primary/10 rounded-lg flex flex-col">
          <span className="text-lg font-bold">{currentTariff || getTariffName(rental.amount)}</span>
          <span className="text-sm text-muted-foreground">Активный тариф</span>
        </div>
        
        <div className="flex justify-between items-center">
          <span className="text-muted-foreground flex items-center gap-1">
            <Calendar className="h-4 w-4" /> Дата начала:
          </span>
          <span className="font-medium">{formatDate(rental.startDate)}</span>
        </div>
        
        {rental.endDate && (
          <div className="flex justify-between items-center">
            <span className="text-muted-foreground flex items-center gap-1">
              <Calendar className="h-4 w-4" /> Дата окончания:
            </span>
            <span className="font-medium">{formatDate(rental.endDate)}</span>
          </div>
        )}
        
        {rental.daysLeft !== undefined && (
          <div className="flex justify-between items-center">
            <span className="text-muted-foreground flex items-center gap-1">
              <Clock className="h-4 w-4" /> Осталось:
            </span>
            <span className={`font-medium ${rental.daysLeft <= 3 ? 'text-destructive' : ''}`}>
              {rental.daysLeft} {rental.daysLeft === 1 ? 'день' : rental.daysLeft <= 4 ? 'дня' : 'дней'}
            </span>
          </div>
        )}
      </CardContent>
      <CardFooter className="flex justify-between">
        <Button 
          variant="outline" 
          onClick={onSelectOtherTariffs}
        >
          Другие тарифы
        </Button>
        <Button 
          variant="refresh"
          onClick={onExtendTariff}
        >
          Продлить
        </Button>
      </CardFooter>
    </Card>
  );
};
